import { render } from "./TableView.vue?vue&type=template&id=30cc0382"
import script from "./TableView.vue?vue&type=script&lang=ts"
export * from "./TableView.vue?vue&type=script&lang=ts"
script.render = render

export default script